<template>
  <div id="app">
    <main>
      <div v-loading="loading">
        <div class="video" v-if="this.listData != '' && this.videotype != '3'">
          <!-- <my-video
            v-if="reFresh"
            :key="menuKey"
            :sources="[{src: vediosrc, type:'video/mp4'}]"
            :options="video.options"
          ></my-video>-->

          <img :src="this.poster" v-show="isBanner" alt="" />
          <div v-show="this.listData != '' && this.videotype != '3' && !isBanner">
            <!--  <VideoCkplayer
              ref="VideoCkplayer"
              :videourl="vediosrc"
              :isLive="true"
              :isHtml5m3u8="true"
            ></VideoCkplayer> -->
            <!-- <JSDecoderPlayer ref="JSDecoderPlayer"></JSDecoderPlayer> -->
            <div @click="togglefull()">
              <JSDecoderPlayer :class="{vidplayer:true,fullscreen:isfull}" ref='JSDecoderPlayer'></JSDecoderPlayer>
            </div>
          </div>
          <el-collapse class="mubottom">
            <el-collapse-item name="1">
              <template slot="title">
                <img src="../img/sp1.png" />明厨亮灶信号源:
              </template>
              <nav class="info">
                <label><i class="el-icon-menu"></i>信号源:</label>
                <div class="info-right">
                  <ul class="info-list">
                    <li v-for="item in listData" :key="item.unid" @click="videoitem(item)"
                      :class="{ videonameactive: item.name == showactive }">
                      {{ item.name }}
                    </li>
                  </ul>
                </div>
              </nav>
            </el-collapse-item>
          </el-collapse>
          <!-- 'application/x-mpegURL' -->
          <!-- <nav class="info">
            <label> <i class="el-icon-menu"></i>明厨亮灶信号源: </label>
            <div class="info-right">
              <ul class="info-list">
                <li
                  v-for="(item, index) in listData"
                  v-show="index < 5"
                  :key="item.unid"
                  @click="videoitem(item)"
                  :class="{ videonameactive: item.name == showactive }"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </nav> -->
        </div>
        <div class="none_video" v-else>
          <img src="../img/bg1.png" v-if="this.videotype == '0'" />
          <img src="../img/bg2.png" v-if="this.videotype == '1'" />
          <img src="../img/bg3.png" v-if="this.videotype == '2'" />
          <img src="../img/bg4.png" v-if="this.videotype == '3'" />
          <img src="../img/bg4.png" v-if="this.videotype == null" />
        </div>
      </div>
    </main>
  </div>
</template>

<script type="text/ecmascript-6">
  import {
    Vedio,
    VedioPlay,
    GetVideoUrl
  } from "../api/api";
  import VideoCkplayer from "@/components/public/VideoCkplayer";
  import JSDecoderPlayer from "@/components/public/JSDecoderPlayer";
  import myVideo from "vue-video";
  import {
    Toast,
    Loadmore,
    Field
  } from "mint-ui";
  export default {
    components: {
      myVideo,
      JSDecoderPlayer,
      "v-loadmore": Loadmore,
    },
    props: ["videotype"],
    data() {
      return {
        activeNames: ["1"],
        menuKey: 1,
        listData: [],
        isfull: false,
        listData1: [],
        reFresh: true,
        vediosrc: "",
        streamType: 0,
        currentitem: {},
        videoData: "",
        isBanner: true, // 是否显示banner图
        isVideo: true, // 是否显示视频
        showactive: "",
        poster: "../../static/img/enterprisepic2.jpg",
        video: {
          options: {
            muted: true,
            volume: 0.6,
            poster: "../../static/img/enterprisepic2.jpg",
          },
        },
        vname: "",
        loading: "",

        isPlay: false,
        playStatus: "",
      };
    },

    // watch: {
    //   listData(val) {
    //     if (val) {
    //       this.loading = false;
    //     }
    //   },
    //   videotype(val, oldval) {
    //     this.getData();
    //   }
    // },
    computed: {},
    methods: {

      togglefull() {
        this.isfull = !this.isfull
        this.$refs.JSDecoderPlayer.init(this.isfull)
        let fd = new FormData()
        fd.append('cameraIndexCode', this.currentitem.cameraIndexCode)
        fd.append('protocol', 'ws')
        let options = {
          params: fd,
        };
        VedioPlay(options).then((res) => {
          if (res.success === true) {
            this.$refs.JSDecoderPlayer.realplay(res.data)
            this.vediosrc = res.data;
            // this.$refs.VideoCkplayer.newVideo();
          }
          console.log(this.vediosrc);
        });

      },
      /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
      // onPlayerPlay(player) {
      //   alert();
      // },

      videoitem(item) {
        this.currentitem = item
        localStorage.setItem("IsOver", true);
        ++this.menuKey;
        // this.playStatus = "autoplay";
        this.reFresh = false;
        console.log(this.reFresh);
        this.vediosrc = "";
        // this.$router.go(0);
        let fd = new FormData();
        fd.append("cameraIndexCode", item.cameraIndexCode);
        fd.append("protocol", "ws");
        let options = {
          params: fd,
        };

        //调取接口
        VedioPlay(options).then((res) => {
          if (res.success === true) {
            this.$refs.JSDecoderPlayer.realplay(res.data)
            this.isBanner = false;
            this.vediosrc = res.data;
            // this.$refs.VideoCkplayer.newVideo();
          }
          console.log(this.vediosrc);
        });

        let instance = Toast({
          message: "成功切换信号源",
          iconClass: "el-icon-check",
        });
        if (item.equipmentStreamType == "MAIN") {
          this.streamType = 0;
        } else {
          this.streamType = 1;
        }
        setTimeout(() => {
          instance.close();
        }, 800);
        this.vname = item.name;
        // this.vediosrc = item.pathHLS;
        this.showactive = this.vname;
        this.isPlay = !this.isPlay;

        this.reFresh = true;
        // this.VideoUrl(item)
      },

      getData() {
        let options = {
          params: {
            unid: JSON.parse(sessionStorage.getItem("WapEnterpriseUnid")).unid,
          },
        };
        //调取接口
        Vedio(options).then((res) => {
          if (res.success === true) {
            this.listData = res.data;
            if (this.listData != 0) {
              // this.vediosrc = this.listData[0].pathHLS;
              this.vname = this.listData[0].name;
              this.showactive = this.vname;
            }
            // this.videotype = JSON.parse(sessionStorage.getItem('Wapvideo')).type
          }
          console.log(res.data);
          let fd = new FormData();
          fd.append("cameraIndexCode", res.data[0].cameraIndexCode);
          fd.append("protocol", "ws");
          let options2 = {
            params: fd,
          };

          VedioPlay(options2).then((res) => {
            if (res.success === true) {
              this.vediosrc = res.data;
              this.$refs.JSDecoderPlayer.realplay(res.data)
            }
            // this.playStatus = "autoplay";
            // this.initVideo()
            console.log(this.vediosrc);
          });
        });
      },
    },
    //页面加载时候
    created() {
      this.getData();
    },
    mounted() {
      // this.getData();
    },
  };

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
  .mubottom {
    margin-bottom: -10px;
  }

  .info {
    background: #efefef;
    overflow: hidden;
    font-size: 0.9rem;

    label {
      width: 70px;
      float: left;
      margin-left: 10px;
      padding: 15px 0px;

      i {
        color: #108def;
      }
    }

    .info-right {
      float: left;
      width: 75%;
      overflow: auto;
      padding: 15px 0px;

      .info-list {
        width: 100%;
      }

      li {
        border: 1px solid #72b9f6;
        padding: 5px 8px;
        border-radius: 15px;
        color: #108dee;
        // display: inline;
        margin-left: 5px;
      }
    }

    .info-right {
      float: left;
      width: 75%;
      overflow: auto;
      padding: 15px 0px;

      .info-list {
        width: 100%;
      }

      li {
        border: 1px solid #72b9f6;
        padding: 5px 8px;
        border-radius: 15px;
        color: #108dee;
        // display: inline;
        margin-left: 5px;
      }

      .videonameactive {
        border: 1px solid #ea1c1c;
        padding: 5px 8px;
        border-radius: 15px;
        color: #ea1c1c !important;
        // display: inline;
        margin-left: 5px;
      }
    }
  }



  .vidplayer {
    width: 95vw;
    height: 56.25vw;
    transform-origin: 0 0;
    transition: all ease 0.3s;
  }

  .fullscreen {
    transform: rotate(90deg);
    height: 100vw !important;
    width: 177.18vw !important;
    position: fixed;
    left: 100vw;
    // top: calc(50vh - 88.59vw);
  }

</style>



// WEBPACK FOOTER //
// videolist.vue?a6a1c764